
import { TemplateCategory } from "./types";

export const tributarioCategory: TemplateCategory = {
  id: "tributario",
  name: "Direito Tributário",
  emoji: "🏛️",
  description: "Documentos para questões tributárias e fiscais",
  subcategories: [
    {
      id: "defesa-tributaria",
      name: "Defesa Tributária",
      emoji: "⚖️",
      templates: [
        {
          id: "mandado-seguranca-tributario",
          name: "Mandado de Segurança contra Lançamento Tributário",
          type: "Petição Inicial",
          description: "Modelo para impugnar lançamento tributário via mandado de segurança",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) FEDERAL DA ___ª VARA DA SEÇÃO JUDICIÁRIA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO] e no CNPJ sob o nº [NÚMERO], com estabelecimento na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 5º, LXIX da Constituição Federal e na Lei nº 12.016/2009, impetrar o presente

MANDADO DE SEGURANÇA

contra ato do(a) [AUTORIDADE COATORA], [QUALIFICAÇÃO DA AUTORIDADE], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O impetrante foi autuado pela autoridade coatora através do Auto de Infração nº [NÚMERO], lavrado em [DATA].

2. O lançamento tributário em questão refere-se a [DESCRIÇÃO DO TRIBUTO E PERÍODO].

3. O ato impugnado é manifestamente ilegal, pois [DESCREVER OS MOTIVOS DA ILEGALIDADE].

4. [DESCREVER OS FATOS ESPECÍFICOS QUE DEMONSTRAM A ILEGALIDADE]

5. O impetrante tem direito líquido e certo à anulação do lançamento tributário.

II - DO DIREITO

O artigo 142 do CTN estabelece que compete privativamente à autoridade administrativa constituir o crédito tributário pelo lançamento.

[FUNDAMENTAÇÃO ESPECÍFICA CONFORME O CASO - ex: prescrição, decadência, ausência de fato gerador, etc.]

O ato administrativo que contraria a lei é nulo de pleno direito.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A concessão de liminar para suspender a exigibilidade do crédito tributário;
b) A citação da autoridade coatora;
c) A procedência para anular o lançamento tributário;
d) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO DÉBITO].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-anulatoria-debito-fiscal",
          name: "Ação Anulatória de Débito Fiscal",
          type: "Petição Inicial",
          description: "Modelo para anular débito fiscal indevidamente constituído",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) FEDERAL DA ___ª VARA DA SEÇÃO JUDICIÁRIA DE _____________

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 103 do Código Tributário Nacional, propor a presente

AÇÃO ANULATÓRIA DE DÉBITO FISCAL

em face da [FAZENDA NACIONAL/ESTADUAL/MUNICIPAL], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A requerente foi constituída em débito fiscal através da [DESCRIÇÃO DO DOCUMENTO - CDA, Auto de Infração, etc.] nº [NÚMERO].

2. O débito refere-se ao tributo [NOME DO TRIBUTO], período de [PERÍODO], no valor de R$ [VALOR].

3. O débito foi constituído de forma irregular, pois [DESCREVER OS VÍCIOS].

4. [DESCREVER OS FUNDAMENTOS ESPECÍFICOS PARA A ANULAÇÃO]

5. A cobrança é indevida e deve ser anulada.

II - DO DIREITO

O artigo 103 do CTN estabelece que somente a lei pode estabelecer os requisitos para a suspensão do crédito tributário.

[FUNDAMENTAÇÃO ESPECÍFICA - ex: prescrição, decadência, falta de notificação, vício de forma, etc.]

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação da requerida;
b) A procedência para declarar a nulidade do débito fiscal;
c) A condenação da requerida nos ônus da sucumbência;
d) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-declaratoria-inexistencia-tributaria",
          name: "Ação Declaratória de Inexistência de Relação Jurídico-Tributária",
          type: "Petição Inicial",
          description: "Modelo para declarar inexistência de obrigação tributária",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) FEDERAL DA ___ª VARA DA SEÇÃO JUDICIÁRIA DE _____________

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 4º do Código de Processo Civil, propor a presente

AÇÃO DECLARATÓRIA DE INEXISTÊNCIA DE RELAÇÃO JURÍDICO-TRIBUTÁRIA

em face da [FAZENDA NACIONAL/ESTADUAL/MUNICIPAL], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A requerente exerce a atividade de [DESCRIÇÃO DA ATIVIDADE] desde [DATA].

2. A Fazenda requerida tem entendimento de que a atividade da requerente está sujeita à incidência do tributo [NOME DO TRIBUTO].

3. Contudo, a atividade exercida pela requerente não se enquadra na hipótese de incidência do referido tributo.

4. [DESCREVER OS MOTIVOS ESPECÍFICOS PELOS QUAIS NÃO HÁ INCIDÊNCIA]

5. Há incerteza jurídica que justifica a presente ação declaratória.

II - DO DIREITO

O artigo 4º do CPC permite a ação declaratória para fazer cessar incerteza ou insegurança jurídica.

[FUNDAMENTAÇÃO ESPECÍFICA - análise da hipótese de incidência, não configuração do fato gerador, etc.]

O tributo somente pode ser exigido quando configurado o fato gerador previsto em lei.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação da requerida;
b) A procedência para declarar a inexistência de relação jurídico-tributária;
c) A condenação da requerida nos ônus da sucumbência;
d) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "embargos-execucao-fiscal",
          name: "Embargos à Execução Fiscal",
          type: "Petição Inicial",
          description: "Modelo para embargos à execução fiscal",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) FEDERAL DA ___ª VARA DA SEÇÃO JUDICIÁRIA DE _____________

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], já qualificado(a) nos autos da Execução Fiscal nº [NÚMERO DO PROCESSO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 16 da Lei nº 6.830/80, opor

EMBARGOS À EXECUÇÃO FISCAL

pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A embargada move contra o embargante execução fiscal com base na CDA nº [NÚMERO].

2. A execução tem por objeto o tributo [NOME DO TRIBUTO], período [PERÍODO], no valor de R$ [VALOR].

3. [DESCREVER OS VÍCIOS QUE FUNDAMENTAM OS EMBARGOS]

4. A execução deve ser extinta, pois [MOTIVO ESPECÍFICO].

II - DO DIREITO

O artigo 16 da Lei 6.830/80 estabelece as matérias que podem ser alegadas em embargos à execução fiscal.

[FUNDAMENTAÇÃO ESPECÍFICA CONFORME A MATÉRIA - ex: prescrição, decadência, pagamento, compensação, etc.]

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A suspensão da execução fiscal;
b) A citação da embargada;
c) A procedência para [PEDIDO ESPECÍFICO - extinção da execução, redução do valor, etc.];
d) A condenação da embargada nos ônus da sucumbência;
e) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "acao-repeticao-indebito-tributario",
          name: "Ação de Repetição de Indébito Tributário",
          type: "Petição Inicial",
          description: "Modelo para restituir valores pagos indevidamente ao Fisco",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) FEDERAL DA ___ª VARA DA SEÇÃO JUDICIÁRIA DE _____________

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 165 do CTN, propor a presente

AÇÃO DE REPETIÇÃO DE INDÉBITO TRIBUTÁRIO

em face da [FAZENDA NACIONAL/ESTADUAL/MUNICIPAL], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O requerente efetuou pagamento do tributo [NOME DO TRIBUTO] no valor de R$ [VALOR] em [DATA].

2. O pagamento foi realizado indevidamente porque [MOTIVO DA INDEVIDA COBRANÇA - ex: ausência de fato gerador, bitributação, etc.].

3. [DESCREVER OS FATOS ESPECÍFICOS QUE DEMONSTRAM O PAGAMENTO INDEVIDO]

4. O requerente tem direito à restituição do valor pago indevidamente, com correção monetária e juros.

5. [MENCIONAR SE HOUVE PEDIDO ADMINISTRATIVO E SEU RESULTADO]

II - DO DIREITO

O artigo 165 do CTN assegura o direito à restituição de tributo pago indevidamente.

[FUNDAMENTAÇÃO ESPECÍFICA - ex: ausência de fato gerador, inconstitucionalidade, ilegalidade, etc.]

O artigo 167 do CTN estabelece que a restituição deve ser feita em dinheiro, com atualização monetária.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação da requerida;
b) A procedência para condenar a requerida a restituir o valor de R$ [VALOR];
c) A correção monetária e juros de mora desde o pagamento indevido;
d) A condenação da requerida nos ônus da sucumbência;
e) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        },
        {
          id: "contestacao-execucao-fiscal",
          name: "Contestação em Execução Fiscal",
          type: "Contestação",
          description: "Modelo para contestar execução fiscal por excesso de execução",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) FEDERAL DA ___ª VARA DA SEÇÃO JUDICIÁRIA DE _____________

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], já qualificado(a) nos autos da Execução Fiscal nº [NÚMERO DO PROCESSO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 16-A da Lei nº 6.830/80, apresentar

CONTESTAÇÃO

pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A exequente move contra o executado execução fiscal com base na CDA nº [NÚMERO].

2. Há excesso de execução, pois o valor cobrado ultrapassa o débito exigível.

3. [DESCREVER OS MOTIVOS DO EXCESSO - ex: pagamentos parciais não computados, juros excessivos, etc.]

4. O valor correto do débito é de R$ [VALOR CORRETO].

II - DO DIREITO

O artigo 16-A da Lei 6.830/80 permite a contestação por excesso de execução.

[FUNDAMENTAÇÃO ESPECÍFICA SOBRE O EXCESSO DE EXECUÇÃO]

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O reconhecimento do excesso de execução;
b) A redução do valor executado para R$ [VALOR CORRETO];
c) A condenação da exequente nos ônus da sucumbência;
d) Os demais pedidos de direito.

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]`
        }
      ]
    },
    {
      id: "regularizacao-tributaria",
      name: "Regularização Tributária",
      emoji: "📋",
      templates: [
        {
          id: "pedido-compensacao-tributaria",
          name: "Pedido de Compensação Tributária",
          type: "Requerimento",
          description: "Modelo para pedido de compensação de tributos",
          icon: "FileText",
          content: `AO(À) EXCELENTÍSSIMO(A) SENHOR(A) [CARGO DA AUTORIDADE ADMINISTRATIVA]
[ÓRGÃO FAZENDÁRIO]

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Senhoria, por meio de seu advogado infra-assinado, com base no artigo 170 do CTN e na [LEGISLAÇÃO ESPECÍFICA], apresentar

PEDIDO DE COMPENSAÇÃO TRIBUTÁRIA

pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O requerente possui crédito tributário no valor de R$ [VALOR] referente a [DESCRIÇÃO DO CRÉDITO - pagamento indevido, recolhimento a maior, etc.].

2. O crédito foi constituído em [DATA] através de [FORMA DE CONSTITUIÇÃO].

3. Simultaneamente, o requerente possui débito tributário no valor de R$ [VALOR] referente ao tributo [NOME DO TRIBUTO], período [PERÍODO].

4. Ambos os valores são da mesma natureza e referem-se à mesma pessoa jurídica.

5. Estão preenchidos os requisitos legais para a compensação.

II - DO DIREITO

O artigo 170 do CTN permite a compensação de créditos tributários com créditos líquidos e certos do sujeito passivo.

[LEGISLAÇÃO ESPECÍFICA APLICÁVEL AO CASO]

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O deferimento do pedido de compensação;
b) A homologação da compensação no valor de R$ [VALOR];
c) A expedição de certidão comprobatória;
d) Os demais pedidos de direito.

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Comprovante do crédito tributário
- Demonstrativo do débito
- Procuração
- Outros documentos pertinentes`
        },
        {
          id: "pedido-parcelamento-moratoria",
          name: "Pedido de Parcelamento ou Moratória",
          type: "Requerimento",
          description: "Modelo para pedido de parcelamento ou moratória de débitos fiscais",
          icon: "FileText",
          content: `AO(À) EXCELENTÍSSIMO(A) SENHOR(A) [CARGO DA AUTORIDADE ADMINISTRATIVA]
[ÓRGÃO FAZENDÁRIO]

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Senhoria, por meio de seu advogado infra-assinado, com base no artigo 151, VI do CTN e na [LEGISLAÇÃO ESPECÍFICA], apresentar

PEDIDO DE [PARCELAMENTO/MORATÓRIA]

pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O requerente possui débito tributário inscrito em dívida ativa sob o nº [NÚMERO DA CDA].

2. O débito refere-se ao tributo [NOME DO TRIBUTO], período [PERÍODO], no valor total de R$ [VALOR].

3. O requerente encontra-se em situação de dificuldade financeira temporária, conforme documentos anexos.

4. [DESCREVER A SITUAÇÃO FINANCEIRA E OS MOTIVOS QUE JUSTIFICAM O PEDIDO]

5. O requerente tem condições de quitar o débito de forma parcelada.

II - DO DIREITO

O artigo 151, VI do CTN estabelece que o parcelamento suspende a exigibilidade do crédito tributário.

[LEGISLAÇÃO ESPECÍFICA QUE AUTORIZA O PARCELAMENTO/MORATÓRIA]

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O deferimento do pedido de [parcelamento/moratória];
b) O parcelamento do débito em [NÚMERO] parcelas de R$ [VALOR];
c) A suspensão da exigibilidade do crédito tributário;
d) A suspensão de eventuais execuções fiscais;
e) Os demais pedidos de direito.

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Demonstrativo financeiro
- Certidão de débito fiscal
- Balanço patrimonial (se pessoa jurídica)
- Declaração de imposto de renda
- Procuração
- Outros documentos pertinentes`
        },
        {
          id: "impugnacao-lancamento-tributario",
          name: "Impugnação de Lançamento Tributário",
          type: "Impugnação",
          description: "Modelo para impugnar lançamento tributário na via administrativa",
          icon: "FileText",
          content: `AO(À) EXCELENTÍSSIMO(A) SENHOR(A) [CARGO DA AUTORIDADE ADMINISTRATIVA]
[ÓRGÃO FAZENDÁRIO]

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Senhoria, por meio de seu advogado infra-assinado, com base no artigo 145 do CTN, apresentar

IMPUGNAÇÃO AO LANÇAMENTO TRIBUTÁRIO

contra o Auto de Infração nº [NÚMERO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O impugnante foi autuado através do Auto de Infração nº [NÚMERO], lavrado em [DATA].

2. O lançamento refere-se ao tributo [NOME DO TRIBUTO], período [PERÍODO], no valor de R$ [VALOR].

3. O lançamento é irregular e deve ser anulado pelos motivos a seguir expostos.

4. [DESCREVER OS VÍCIOS ESPECÍFICOS DO LANÇAMENTO]

5. Estão presentes os requisitos legais para a anulação do lançamento.

II - DO DIREITO

O artigo 145 do CTN estabelece o direito do contribuinte de impugnar o lançamento tributário.

[FUNDAMENTAÇÃO ESPECÍFICA - ex: prescrição, decadência, ausência de fato gerador, vício de forma, etc.]

O lançamento eivado de vício é nulo de pleno direito.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O conhecimento da presente impugnação;
b) A anulação do Auto de Infração nº [NÚMERO];
c) O cancelamento do lançamento tributário;
d) Os demais pedidos de direito.

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Cópia do Auto de Infração
- Documentos comprobatórios
- Procuração
- Outros documentos pertinentes`
        }
      ]
    },
    {
      id: "restituicoes-ressarcimentos",
      name: "Restituições e Ressarcimentos",
      emoji: "💰",
      templates: [
        {
          id: "pedido-restituicao-administrativa",
          name: "Pedido de Restituição Administrativa",
          type: "Requerimento",
          description: "Modelo para pedido de restituição de tributos na via administrativa",
          icon: "FileText",
          content: `AO(À) EXCELENTÍSSIMO(A) SENHOR(A) [CARGO DA AUTORIDADE ADMINISTRATIVA]
[ÓRGÃO FAZENDÁRIO]

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Senhoria, por meio de seu advogado infra-assinado, com base no artigo 165 do CTN, apresentar

PEDIDO DE RESTITUIÇÃO

pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O requerente efetuou pagamento do tributo [NOME DO TRIBUTO] no valor de R$ [VALOR] em [DATA].

2. O pagamento foi realizado indevidamente ou a maior, conforme comprovantes anexos.

3. [DESCREVER OS MOTIVOS QUE JUSTIFICAM A RESTITUIÇÃO]

4. O requerente faz jus à restituição do valor pago indevidamente.

5. Requer-se a restituição com correção monetária e juros.

II - DO DIREITO

O artigo 165 do CTN assegura o direito à restituição de tributo pago indevidamente.

[FUNDAMENTAÇÃO ESPECÍFICA CONFORME O CASO]

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O deferimento do pedido de restituição;
b) A restituição do valor de R$ [VALOR] com correção monetária;
c) A aplicação de juros legais desde o pagamento indevido;
d) Os demais pedidos de direito.

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Comprovantes de pagamento
- Documentos que justificam a restituição
- Procuração
- Outros documentos pertinentes`
        },
        {
          id: "pedido-ressarcimento-pis-cofins",
          name: "Pedido de Ressarcimento de PIS/COFINS",
          type: "Requerimento",
          description: "Modelo específico para ressarcimento de PIS/COFINS sobre insumos",
          icon: "FileText",
          content: `AO(À) EXCELENTÍSSIMO(A) SENHOR(A) DELEGADO(A) DA RECEITA FEDERAL
[DELEGACIA DA RECEITA FEDERAL]

[NOME COMPLETO], [QUALIFICAÇÃO COMPLETA], vem, respeitosamente, perante Vossa Senhoria, por meio de seu advogado infra-assinado, com base na Lei nº 10.865/2004, apresentar

PEDIDO DE RESSARCIMENTO DE PIS/COFINS

pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. A requerente exerce atividade de [DESCRIÇÃO DA ATIVIDADE] e está sujeita ao regime não-cumulativo do PIS/COFINS.

2. A empresa utiliza em seu processo produtivo insumos sobre os quais incidiram PIS/COFINS.

3. [DESCREVER OS INSUMOS E SUA UTILIZAÇÃO NO PROCESSO PRODUTIVO]

4. A requerente faz jus ao ressarcimento dos valores recolhidos sobre os insumos.

5. O valor a ser ressarcido é de R$ [VALOR], referente ao período de [PERÍODO].

II - DO DIREITO

A Lei nº 10.865/2004 permite o ressarcimento de PIS/COFINS incidente sobre insumos utilizados no processo produtivo.

[FUNDAMENTAÇÃO ESPECÍFICA SOBRE O DIREITO AO RESSARCIMENTO]

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) O deferimento do pedido de ressarcimento;
b) O ressarcimento do valor de R$ [VALOR];
c) A correção monetária desde o recolhimento indevido;
d) Os demais pedidos de direito.

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Demonstrativo dos valores pagos
- Comprovantes dos insumos utilizados
- Procuração
- Outros documentos pertinentes`
        }
      ]
    }
  ]
};
